import Button from '@material-ui/core/Button';
import React from 'react';
import Link from 'react-router/lib/Link';
import './TriggerNotificationPopover.styl';
import BulletedRuleDescription from 'components/triggers/BulletedRuleDescription';
import {withRouter} from 'react-router';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';

function TriggerNotificationPopover({items, router}) {
  return (
    <div className="trigger-notif-wrapper">
      <h2 className="popover-header">Smart Alerts</h2>
      {items.map((item, i) => (
        <div className="rule-row" key={i}>
          <BulletedRuleDescription text={item.context.ruleName} />
          <div className="rule-link">
            {item.context.active ? (
              <ThemeProvider theme={lightTheme}>
                <Button
                  component={Link}
                  variant="outlined"
                  className="rule-link-button ev-button"
                  to={{
                    pathname: '/admin/actions/' + item.context.ruleId,
                    state: {goBack: router.createLocation(window.location)},
                  }}>
                  View Smart Alert
                </Button>
              </ThemeProvider>
            ) : (
              <div className="rule-disabled">&lt;Smart Alert deleted&gt;</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default withRouter(TriggerNotificationPopover);
